module.exports = __webpack_public_path__ + "img/zcfz2.84924873.png";